import { ref, readonly } from 'vue'
import { api } from '@/lib/api'
import type { ImpersonationStatus } from '@/lib/types'

const impersonating = ref(false)
const impersonatedOrgId = ref('')
const impersonatedOrgName = ref('')
const loading = ref(false)

function setStatus(status: ImpersonationStatus) {
  impersonating.value = status.impersonating
  impersonatedOrgId.value = status.orgId ?? ''
  impersonatedOrgName.value = status.orgName ?? ''
}

function clearStatus() {
  impersonating.value = false
  impersonatedOrgId.value = ''
  impersonatedOrgName.value = ''
}

async function checkStatus() {
  try {
    const status = await api.adminGetImpersonationStatus()
    setStatus(status)
  } catch {
    clearStatus()
  }
}

async function startImpersonation(orgId: string) {
  loading.value = true
  try {
    const result = await api.adminStartImpersonation(orgId)
    impersonating.value = true
    impersonatedOrgId.value = result.orgId
    impersonatedOrgName.value = result.orgName
    // Reload the page to pick up the new cookie-based context
    window.location.href = '/dashboard'
  } catch (e) {
    throw e
  } finally {
    loading.value = false
  }
}

async function exitImpersonation() {
  loading.value = true
  try {
    await api.adminExitImpersonation()
    clearStatus()
    // Reload to clear cookie-based context
    window.location.href = '/admin'
  } catch (e) {
    throw e
  } finally {
    loading.value = false
  }
}

export function useImpersonation() {
  return {
    impersonating: readonly(impersonating),
    impersonatedOrgId: readonly(impersonatedOrgId),
    impersonatedOrgName: readonly(impersonatedOrgName),
    loading: readonly(loading),
    checkStatus,
    startImpersonation,
    exitImpersonation,
  }
}
